<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="skeleton-table-title skeleton-animate mb-3"></div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                v-for="n in 4"
                :key="n"
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                <div class="skeleton-header skeleton-animate"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in 5" :key="row">
              <td v-for="col in 4" :key="col">
                <div class="skeleton-cell skeleton-animate"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-animate {
  animation: skeleton-loading 1.5s infinite;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-table-title {
  height: 18px;
  width: 150px;
  border-radius: 4px;
}

.skeleton-header {
  height: 14px;
  width: 80%;
  margin: 8px 0;
}

.skeleton-cell {
  height: 16px;
  width: 90%;
  margin: 12px 0;
}
</style>
